"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var modal_1 = __importDefault(require("../../plugins/modal"));
var OosModal = function (_a) {
    var variant = _a.variant, klaviyoEventName = _a.klaviyoEventName, klaviyoEventData = _a.klaviyoEventData, isOpen = _a.isOpen, handleModalClose = _a.handleModalClose;
    var _b = __read((0, react_1.useState)(''), 2), OOSEmail = _b[0], setOOSEmail = _b[1];
    var _c = __read((0, react_1.useState)(false), 2), isOOSSignupDone = _c[0], setIsOOSSignupDone = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isSubmitting = _d[0], setIsSubmitting = _d[1];
    var onSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    e.preventDefault();
                    setIsSubmitting(true);
                    if (!klaviyoEventName) return [3 /*break*/, 1];
                    (_a = window._learnq) === null || _a === void 0 ? void 0 : _a.push(['identify', { $email: OOSEmail }]);
                    (_b = window._learnq) === null || _b === void 0 ? void 0 : _b.push(['track', klaviyoEventName, klaviyoEventData || {}]);
                    return [3 /*break*/, 4];
                case 1:
                    if (!variant) return [3 /*break*/, 3];
                    // https://help.klaviyo.com/hc/en-us/articles/360006565332-Back-in-Stock-for-Mobile-App-Developers
                    return [4 /*yield*/, fetch('https://a.klaviyo.com/api/v1/catalog/subscribe', {
                            body: "a=".concat(window.klaviyoCompanyId, "&email=").concat(OOSEmail, "&variant=").concat(variant.id, "&platform=shopify"),
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                            },
                            method: 'POST',
                            mode: 'no-cors',
                        })];
                case 2:
                    // https://help.klaviyo.com/hc/en-us/articles/360006565332-Back-in-Stock-for-Mobile-App-Developers
                    _c.sent();
                    return [3 /*break*/, 4];
                case 3: throw new Error('Invalid parameters');
                case 4:
                    setIsSubmitting(false);
                    setIsOOSSignupDone(true);
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement(modal_1.default, { handleClose: handleModalClose, isOpen: isOpen },
        react_1.default.createElement("div", { className: 'padding-horizontal-4 padding-vertical-8', style: { backgroundColor: '#f5f5f7', maxWidth: 500 } }, isOOSSignupDone ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h3", { className: 'h4' }, "Thank you!"),
            react_1.default.createElement("div", { className: 'font-lighter margin-top-4' }, "We will notify you when the product is in stock."))) : (react_1.default.createElement("form", { onSubmit: onSubmit },
            react_1.default.createElement("h3", { className: 'h4' }, "Product Coming Soon!"),
            react_1.default.createElement("div", { className: 'font-lighter margin-vertical-4' }, "Get notified when it\u2019s back in stock! Enter your email and you\u2019ll be one of the first to know when this product is available."),
            react_1.default.createElement("input", { type: 'email', name: 'email', className: 'padding-horizontal-4 padding-vertical-6 large display-block', placeholder: 'Enter your email', required: true, onChange: function (e) { return setOOSEmail(e.target.value); }, disabled: isSubmitting }),
            react_1.default.createElement("input", { type: 'submit', className: 'large button light-wisteria width-100', style: { fontSize: '22px' }, disabled: isSubmitting, onClick: onSubmit, value: 'Get Notified' }))))));
};
exports.default = OosModal;
